import $ from "jquery";
import Swiper from "swiper";
import { Navigation } from "swiper/modules";

const VIDEO_EXTENSIONS = /\.(mp4|webm|ogg|mov)(\?.*)?$/i;

const plansTestimonial = {
  init: function () {
    $(".plans-testimonial").each(function () {
      const $section  = $(this);
      const swiperEl  = $section.find(".plans-testimonial__swiper-container").get(0);
      const $prevBtn  = $section.find(".plans-testimonial__nav-prev");
      const $nextBtn  = $section.find(".plans-testimonial__nav-next");
      const $current  = $section.find(".plans-testimonial__nav-current");
      const $total    = $section.find(".plans-testimonial__nav-total");
      const $modal    = $section.find(".plans-testimonial__video-modal");
      const $video    = $modal.find(".plans-testimonial__video-player");
      const $close    = $modal.find(".plans-testimonial__video-modal-close");
      const $backdrop = $modal.find(".plans-testimonial__video-modal-backdrop");

      if (!swiperEl) {return;}

      const swiper = new Swiper(swiperEl, {
        modules: [Navigation],
        slidesPerView: 1,
        spaceBetween: 24,
        navigation: {
          prevEl: $prevBtn.get(0),
          nextEl: $nextBtn.get(0),
        },
        on: {
          init: function () {
            plansTestimonial.updateCounter(this, $current, $total);
            plansTestimonial.updateNavState(this, $prevBtn, $nextBtn);
          },
          slideChange: function () {
            plansTestimonial.updateCounter(this, $current, $total);
            plansTestimonial.updateNavState(this, $prevBtn, $nextBtn);
          },
        },
      });

      swiperEl._swiper = swiper;

      // Ensure nav state is correct after Swiper initialises
      plansTestimonial.updateCounter(swiper, $current, $total);
      plansTestimonial.updateNavState(swiper, $prevBtn, $nextBtn);

      // Video modal: intercept CTA clicks for video URLs
      $section.on("click", ".plans-testimonial__cta-btn", function (e) {
        const url = $(this).data("video-url") || "";
        if (!VIDEO_EXTENSIONS.test(url)) {return;}
        e.preventDefault();
        $video.attr("src", url);
        // Captions track (WCAG 1.2.2) — native controls show the CC menu for it
        $video.find("track").remove();
        const captionsUrl = $(this).attr("data-captions-url");
        if (captionsUrl) {
          $("<track>", {
            kind: "captions",
            src: captionsUrl,
            srclang: $(this).attr("data-captions-lang") || "en",
            label: $(this).attr("data-captions-label") || "English",
          }).appendTo($video);
        }
        $modal.attr("aria-hidden", "false").addClass("is-open");
        $video.get(0).play();
      });

      function closeModal() {
        $modal.attr("aria-hidden", "true").removeClass("is-open");
        const videoEl = $video.get(0);
        videoEl.pause();
        videoEl.removeAttribute("src");
        videoEl.load();
      }

      $close.on("click", closeModal);
      $(document).on("keydown.plansTestimonialModal", function (e) {
        if (e.key === "Escape" && $modal.hasClass("is-open")) {closeModal();}
      });
    });
  },

  updateCounter: function (swiper, $current, $total) {
    $current.text(swiper.activeIndex + 1);
    $total.text(swiper.slides ? swiper.slides.length : 0);
  },

  updateNavState: function (swiper, $prevBtn, $nextBtn) {
    $prevBtn.prop("disabled", swiper.isBeginning);
    $nextBtn.prop("disabled", swiper.isEnd);
  },
};

$(document).ready(function () {
  if ($(".plans-testimonial").length > 0) {
    plansTestimonial.init();
  }
});
